import { FivIcon } from './icon.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@NgModule({
  declarations: [FivIcon],
  imports: [CommonModule, IonicModule],
  exports: [FivIcon]
})
export class FivIconModule {}
